import { styled } from "@mui/material/styles";

const StyledCheckInbox = styled("div")(
  ({ theme }) => `
  .checkInbox-wrap {
  width: 27%;
  margin: 0 auto;
  padding: 30px 0;
  text-align: center;
   display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;

  @media screen and (max-width: 1024px) {
    width: 60%;
  }

  @media screen and (max-width: 480px) {
    width: 80%;
  }
}

.body-wrap {
  display: flex;
   flex-direction: column;
   gap: 20px;
}
.header {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 400;
  font-size: 24px;
  font-style: normal;
  line-height: 30px;
}   
.body-text {
  font-family: Lexend;
  color: ${theme.palette.customColor.secondarySecond};
  font-weight: 300;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
}
.body-text span {
text-decoration: underline;
  color: ${theme.palette.primary.main};
}
.rest-link {
  font-family: Lexend;
  color: ${theme.palette.primary.main};
  font-weight: 300;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
}       

.checkInbox-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.circleIcon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(238, 217, 199, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.backLogin {
  text-align: center;
}
.backLogin a {
  font-family: Lexend;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.palette.primary.main};
  text-decoration: underline
}    
  `
);

export default StyledCheckInbox;
